import chroma from "chroma-js";
import invert from "invert-color";

export enum ColorLabels {
  PRIMARY = 0,
  SECONDARY = 1,
  BACKGROUND = 2,
  PRIMARY_FONT = 3,
  VISUALS = 4,
  SECONDARY_FONT = 5,
  VISUALS_2 = 6,
  VISUALS_3 = 7,
}

export enum ButtonColorLabels {
  BACKGROUND = 0,
  FONT = 1,
  BORDER = 2,
}

/***
 * @note: This function does not invert colors, it will only return the black light color or white for a dark color.
 */
export function getInvertedColor(color: string) {
  if (!chroma.valid(color)) {
    return;
  }

  const rgb = chroma(color).rgb();
  return invert(rgb, true);
}

export function brightenColor(color: string, alpha: number) {
  if (!chroma.valid(color)) {
    return;
  }

  return chroma(color).brighten(alpha).hex("rgb");
}

export function darkenColor(color: string, alpha: number) {
  if (!chroma.valid(color)) {
    return;
  }

  return chroma(color).darken(alpha).hex("rgb");
}

export function getColor(color: string) {
  let result = color;
  if (color === "transparent" || !chroma.valid(color)) {
    result = "#ffffff00";
  }
  return chroma(result);
}
